import * as createPointOfInterestImage from 'store/actions/pointsofinterest/images/createPointsOfInterestImage';
import * as deletePointOfInterestImage from 'store/actions/pointsofinterest/images/deletePointsOfInterestImage';
import * as fetchPointOfInterestImages from 'store/actions/pointsofinterest/images/fetchPointsOfInterestImages';
import * as setPointOfInterestHighlightedImage from 'store/actions/pointsofinterest/images/setHighlightedPointsOfInterestImage';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import * as types from 'store/actions/types';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* fetchPointOfInterestImagesAsync({ payload }) {
    try {
        const params = Object.assign({
            includes: [
                'images',
                'imageVersions',
            ],
        }, {});

        const url = `${ config.getApiBaseUrl() }/points-of-interest/${ payload.id }/images`;

        const response = yield apiClient.read(url, params);

        yield put(fetchPointOfInterestImages.fetchPointOfInterestImagesSuccess(payload, response));
    } catch (error) {
        yield put(fetchPointOfInterestImages.fetchPointOfInterestImagesFailure(error));
    }
}

function* createPointOfInterestImageAsync({ payload }) {
    const { id, formData } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/points-of-interest/${ id }/images?includes[]=images&includes[]=imageVersions`;

        const response = yield apiClient.createFile(url, formData);

        yield put(createPointOfInterestImage.createPointOfInterestImageSuccess(payload, response));

        yield put(showNotification('notifications.points_of_interest.images.create.success'));
    } catch (error) {
        yield put(createPointOfInterestImage.createPointOfInterestImageFailure(error));
    }
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

function* deletePointOfInterestImageAsync({ payload }) {
    const {
        id,
        point_of_interest_id,
    } = payload;

    try {

        const url = `${ config.getApiBaseUrl() }/points-of-interest/${ point_of_interest_id }/images/${ id }`;

        yield apiClient.delete(url);

        yield put(deletePointOfInterestImage.deletePointOfInterestImageSuccess(payload));

        yield put(showNotification('notifications.points_of_interest.images.delete.success'));
    } catch (error) {
        yield put(deletePointOfInterestImage.deletePointOfInterestImageFailure(error));
    }
}

function* setHighlightedPointOfInterestImageAsync({ payload }) {
    const { id, point_of_interest_id, is_highlighted } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/points-of-interest/${ point_of_interest_id }/images/${ id }`;
        const response = yield apiClient.patch(url, { is_highlighted });

        yield put(setPointOfInterestHighlightedImage.setHighlightedPointsOfInterestImageSuccess(point_of_interest_id, response));
    } catch (error) {
        yield put(setPointOfInterestHighlightedImage.setHighlightedPointsOfInterestImageFailure(error));
    }
}

export default function* pointsOfInterestImagesSagas() {
    yield [
        takeEvery(types.CREATE_POINT_OF_INTEREST_IMAGE, createPointOfInterestImageAsync),
        takeEvery(types.CREATE_POINT_OF_INTEREST_IMAGE_FAILURE, failureMessage),

        takeEvery(types.FETCH_POINT_OF_INTEREST_IMAGES, fetchPointOfInterestImagesAsync),
        takeEvery(types.FETCH_POINT_OF_INTEREST_IMAGES_FAILURE, failureMessage),

        takeEvery(types.DELETE_POINT_OF_INTEREST_IMAGE, deletePointOfInterestImageAsync),
        takeEvery(types.DELETE_POINT_OF_INTEREST_IMAGE_FAILURE, failureMessage),

        takeEvery(types.SET_HIGHLIGHTED_POI_IMAGE, setHighlightedPointOfInterestImageAsync),
        takeEvery(types.SET_HIGHLIGHTED_POI_IMAGE_FAILURE, failureMessage),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/pointsOfInterestImagesSagas.js